import reportErrorToFaro from './reportErrorToFaro';

const getParentDomain = () => {
  const defaultDomain = window.location.origin;
  const isIframed = window.self !== window.top;

  if (!isIframed) {
    return defaultDomain;
  }
  try {
    if (window.top) {
      return window.top.location.origin;
    }
  } catch (e: unknown) {
    if (document.referrer) {
      try {
        return new URL(document.referrer).origin;
      } catch (urlError) {
        reportErrorToFaro(urlError, `Error generating url from document.referrer: ${document.referrer} ${(e as Error).message}`);
      }
    }
  }

  return defaultDomain;
};

export default {
  getParentDomain,
};
